export default {
    background: "#eee",
    black: "#2C2E2F",
    blue: "#007AFF",

    blackTransparent: "rgba(0.0, 0.0, 0.0, 0.7)",
    darkYellow: "#df690e",
    mediumGrey: "#ddd",
    darkGrey: "#999",
    lightGrey: "#ccc",
    emerald: "#0e8d72",
    green: "#22C064",
    grey: "#bac0c3",
    red: "#EE315E",
    darkWhite: "#f7f7f7",
    white: "#fff",
    yellow: "#ffa000"
};
